module.exports = __webpack_public_path__ + "img/LUB00222.5d850e8d.png";